import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTvSubscribersAsync, getTvSubscribersForRegistration, getCatalogAsync, premiumPackageActionAsync, checkInfo } from './premiumPackagesCatalogAsyncThunk';

const initialState = {
  page: "",
  epiData: {
    defaultImage: "",
    joinTvServiceLink: "",
    updatePaymentLink: "",
    debtPaymentLink: ""
  },
  isCustomerEntered: false,
  tvSubscribers: null,
  selectedSubscriber: null,
  availablePackages: [],
  installedPackages: [],
  productWorldList: [],
  premiumPackagesWorlds: [],
  selectedTab: 'newPackages',
  selectedPackage: null,
  selectedPackageRoute: null,
  subPackages: {
    selected: [],
  },
  totalPrice: 0,
  action: '',
  selectedPackagesDWH: [],
  popup: {
    packagesCount: 0,
    packageTitle: '',
    isDisplay: false,
    type: '',
    text: '',
  },
  errorPage: {
    isDisplay: false,
    id: 0,
    type: '',
    description: ''
  },
  loader: {
    isDisplay: false,
    title: ''
  },
  isBackNavigationDone: false,
  isListenerAdded: false,
  isCameFromSelfCarePage: false,
  isHboMaxSale: false,
  isDisneySale: false,
  hboStatus: null,
  disneyStatus: null,
  provisioningPage: {
    title: '',
    subtitle: '',
    actionBtnText: '',
    isComplete: false,
    isTimeout: false,
    wasConnected: false,
    timeoutImage: null,
    hideActionBtn: false,
    pollingProvider: '',
    pollingParams: null,
    pollingIntervalMs: 10000,
    pollingCount: 0,
    maxPollingAttempts: 6,
  },
};

const PremiumPackagesCatalogSlice = createSlice({
  name: 'premiumPackagesCatalog',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
      reducer: (state, action) => {
        state.epiData.defaultImage = action.payload.defaultImage;
        state.epiData.joinTvServiceLink = action.payload.joinTvServiceLink;
        state.epiData.updatePaymentLink = action.payload.updatePaymentLink;
        state.epiData.debtPaymentLink = action.payload.debtPaymentLink;
        state.isBackNavigationDone = false;
        state.isListenerAdded = false;
      },
      prepare: (action) => {
        let payload = {};
        const epiData = action.premiumPackagesCatalogBlock;
        payload.defaultImage = epiData.defaultImage.value.url;
        payload.joinTvServiceLink = epiData.joinTvServiceLink.value;
        payload.updatePaymentLink = epiData.updatePaymentLink.value;
        payload.debtPaymentLink = epiData.debtPaymentLink.value;

        return { payload: payload };
      },
    },
    setIsCustomerEntered: (state, action) => {
      state.isCustomerEntered = action.payload;
    },
    redirectToLogin: (state, action) => { },
    clearSelection: (state, action) => {
      state.subPackages = {
        selected: [],
      };
      state.selectedPackageRoute = null;
      state.selectedPackagesDWH = [];
      state.totalPrice = 0;
    },
    clearSubscribers: (state, action) => {
      state.tvSubscribers = null;
      state.selectedSubscriber = null;
    },
    setIsSubmit: (state, action) => {
      state.isSubmit = action.payload;
    },
    goToPage: (state, action) => {
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    setLoader: (state, action) => {
      state.loader.isDisplay = action.payload.isDisplay;
      state.loader.title = action.payload.title;
    },
    setErrorPage: (state, action) => {
      state.errorPage.isDisplay = action.payload.isDisplay;
      state.errorPage.id = action.payload.id;
      state.errorPage.type = action.payload.type;
      state.errorPage.description = action.payload.description;
      //   if (action.payload.isOpenWorkOrder) {
      //   }
      state.page = 'errorPage';
    },
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
      const title = action.payload.cmsData?.title ? action.payload.cmsData?.title : action.payload.localizedName;
      const duration = action.payload.duration ? getPremiumPackageDuration(action.payload.duration) : '';
      const packageName = title + ' ' + duration;
      state.selectedPackagesDWH = [packageName];
      state.totalPrice = action.payload.price ? Math.abs(parseFloat(action.payload.price).toFixed(2)) : '';
    },
    setSelectedPackageRoute: (state, action) => {
      state.selectedPackageRoute = action.payload;
      const title = action.payload.cmsData?.title ? action.payload.cmsData?.title : action.payload.localizedName;
      const duration = getPremiumPackageDuration(action.payload.duration);
      const packageName = title + (duration ? ' ' + duration : '');
      state.selectedPackagesDWH = [packageName];
      state.totalPrice = action.payload.price ? Math.abs(parseFloat(action.payload.price).toFixed(2)) : '';
    },
    setSelectedSubPackages: (state, action) => {
      const title = action.payload.item.cmsData?.title ? action.payload.item.cmsData?.title : action.payload.item.localizedName;
      const duration = getPremiumPackageDuration(action.payload.item.duration);
      const packageName = title + ' ' + duration;

      if (action.payload.isSelected) {
        if (action.payload.isSingleChoice) {
          state.totalPrice = action.payload.item.price ? Math.abs(parseFloat(action.payload.item.price).toFixed(2)) : 0;
          state.subPackages.selected = [{ worldName: action.payload.worldName, name: action.payload.item.name, count: 1, title: title, termsLink: action.payload.item.cmsData.termsLink, lawText: action.payload.item?.cmsData?.selfCare?.lawText }];
          state.selectedPackagesDWH = [packageName];
        }
        else {
          state.totalPrice = Math.abs((parseFloat(state.totalPrice) + parseFloat(action.payload.item.price)).toFixed(2));
          state.subPackages.selected.push({ worldName: action.payload.worldName , name: action.payload.item.name, count: 1, title: title, termsLink: action.payload.item.cmsData.termsLink, lawText: action.payload.item?.cmsData?.selfCare?.lawText });
          state.selectedPackagesDWH.push(packageName);
        }
      }
      else {
        if (state.totalPrice > 0) {
          state.totalPrice = Math.abs((parseFloat(state.totalPrice) - parseFloat(action.payload.item.price)).toFixed(2));
        }
        state.subPackages.selected = state.subPackages.selected.filter(x => x.name != action.payload.item.name);
        state.selectedPackagesDWH = state.selectedPackagesDWH.filter(x => x != packageName);

      }
    },
    setSelectedSubscriber: (state, action) => {
      state.selectedSubscriber = action.payload;
    },
    setPopUp: (state, action) => {
      state.popup.isDisplay = action.payload.isDisplay;
      state.popup.type = action.payload.type;
      state.popup.packageTitle = '';
      if (action.payload.packagesCount) {
        state.popup.packagesCount = action.payload.packagesCount;
      }
      if (action.payload.packageTitle) {
        state.popup.packageTitle = action.payload.packageTitle;
      }
      if (action.payload.text) {
        state.popup.text = action.payload.text;
      }
    },
    setAction: (state, action) => {
      state.action = action.payload;
    },
    setIsBackNavigationDone: (state, action) => {
      state.isBackNavigationDone = action.payload;
    },
    setIsListenerAdded: (state, action) => {
      state.isListenerAdded = action.payload;
    },
    setIsCameFromSelfCarePage: (state, action) => {
      state.isCameFromSelfCarePage = action.payload;
    },
    setProvisioningPage: (state, action) => {
      state.provisioningPage = { ...action.payload, isComplete: false, wasConnected: false, pollingCount: 0, maxPollingAttempts: action.payload.maxPollingAttempts ?? 6, pollingIntervalMs: action.payload.pollingIntervalMs ?? 10000 };
    },
    setProvisioningPageComplete: (state, action) => {
      state.provisioningPage.isComplete = true;
      state.provisioningPage.wasConnected = action.payload?.wasConnected ?? false;
      if (action.payload?.title) state.provisioningPage.title = action.payload.title;
      if (action.payload?.subtitle) state.provisioningPage.subtitle = action.payload.subtitle;
      if (action.payload?.actionBtnText) state.provisioningPage.actionBtnText = action.payload.actionBtnText;
    },
    setProvisioningPageTimeout: (state, action) => {
      state.provisioningPage.isComplete = true;
      state.provisioningPage.isTimeout = true;
      state.provisioningPage.hideActionBtn = true;
      if (action.payload?.title) state.provisioningPage.title = action.payload.title;
      if (action.payload?.subtitle) state.provisioningPage.subtitle = action.payload.subtitle;
      if (action.payload?.timeoutImage) state.provisioningPage.timeoutImage = action.payload.timeoutImage;
    },
    incrementPollingCount: (state) => {
      state.provisioningPage.pollingCount += 1;
    },
    reportAnalytics: (state, action) => { },
    reportDWH: (state, action) => { },
  },
  extraReducers: {
    [getTvSubscribersAsync.fulfilled]: (state, action) => {
      if (!action.payload || !action.payload.tvSubscriberList) { return; }
      state.tvSubscribers = action.payload.tvSubscriberList;
    },
    [getTvSubscribersForRegistration.fulfilled]: (state, action) => {
      const {error, tvSubscriberList} = action.payload || {};
      if (error || !Array.isArray(tvSubscriberList)) { return; }
      state.tvSubscribers = tvSubscriberList;
    },
    [checkInfo.fulfilled]: (state, action) => {
    },
    // [getCatalogAsync.fulfilled]: (state, action) => {
    //   if (!action.payload) { return; }
    //   state.availablePackages = action.payload.availablePackages;
    //   state.installedPackages = action.payload.installedPackages;
    //   //state.premiumPackagesWorlds = action.payload.premiumPackagesWorlds;
    // },
    [getCatalogAsync.fulfilled]: (state, action) => {
      if (!action.payload) { return; }
      state.installedPackages = action.payload.installedPackages;
      state.availablePackages = action.payload.availablePackages;
      state.hboStatus = action.payload.hboStatus ?? null;
      state.disneyStatus = action.payload.disneyStatus ?? null;
      if (state.selectedPackage) {
        let selectedPackage = action.payload.availablePackages.find(x => x.name == state.selectedPackage.name);
        if (selectedPackage != undefined) {
          state.selectedPackage = selectedPackage;
        }
        // else {
        //   state.selectedPackage = action.payload.installedPackages.find(x => x.name == state.selectedPackage.name);
        // }
      }
    },
    [premiumPackageActionAsync.fulfilled]: (state, action) => {
      if (action.payload?.additionalResultValue?.isHboMax === 'true') {
        state.isHboMaxSale = true;
      }
      if (action.payload?.additionalResultValue?.isDisney === 'true') {
        state.isDisneySale = true;
      }
    }
  },
});

export const {
  resetBlock,
  initBlock,
  clearSelection,
  clearSubscribers,
  goToPage,
  redirectToLogin,
  setLoader,
  setPopUp,
  setIsSubmit,
  setErrorPage,
  setSelectedTab,
  setSelectedPackage,
  setSelectedSubPackages,
  setSelectedPackageRoute,
  setSelectedSubscriber,
  setPremiumPackageChanged,
  resetPremiumPackage,
  setAction,
  setIsListenerAdded,
  setIsBackNavigationDone,
  setIsCameFromSelfCarePage,
  setProvisioningPage,
  setProvisioningPageComplete,
  setProvisioningPageTimeout,
  incrementPollingCount,
  reportAnalytics,
  reportDWH
} = PremiumPackagesCatalogSlice.actions;

export default PremiumPackagesCatalogSlice.reducer;


function getPremiumPackageDuration(duration) {
  if (duration.amount == 0) {
    return 'חודשי';
  }
  else {
    return '';
  }
}


function buildPriceItemList(priceItemList){
  let priceItems = priceItemList;
  if(priceItems?.length > 0){
    priceItems?.map((item) => {
      if(item.amount){
        if( parseInt(item.amount) == 1 ){
          item.priceText = 'לחודש הראשון';
        }
        else if( parseInt(item.amount) == 2 ){
          item.priceText = 'לחודשיים הראשונים';
        }
        else{
          item.priceText =  'ל' + (item.amount + ' חודשים') + ' ראשונים';
        }
        item.totalPrePriceText = 'מנוי חודשי מתחדש';
        item.totalPriceText = item.priceText ;
      }else if(item.to == 0 && item.from == item.to ){ //from and to = 0
        item.priceText = '';
      }else if(((item.from == 0 || item.from == 1) && item.from < item.to)){
        const monthsText = ['חודש' , 'חודשיים' , (item.to + ' חודשים') ]
        const monthText  = item.to == 2 ?  monthsText[1] : monthsText[2];
        item.priceText = item.to == 1 ? 'לחודש הראשון' : ' ל' + monthText + ' חודשים ' ;
        item.totalPrePriceText = 'סה"כ חיוב חודשי ל ' + item.priceText ;
        item.totalPriceText = 'לחודש';
      }else if(item.to == 0 && item.from > item.to){
        if(item.from == 1 ){
          item.priceText = 'לחודש';
          item.totalPrePriceText = 'סה"כ לתשלום' ;
        }
        else{
          item.priceText = 'ולאחר מכן';
          item.totalPrePriceText = 'סה"כ חיוב חודשי לאחר מכן' ;
        }
        item.totalPriceText = 'לחודש';
      }
      else if(item.to != 0 && item.from < item.to){
        item.priceText = 'מחודש ' + item.from + ' עד חודש ' + item.to;
        item.totalPrePriceText = 'סה"כ חיוב חודשי ' + item.priceText;
        item.totalPriceText = 'לחודש';
      }
      else if(item.to != 0 && item.from == item.to){
        const monthsText = ['ראשון' , 'שני' , 'שלישי', 'רביעי' ]
        item.priceText = 'חיוב חודשי בחודש ה' + (item.from < 4 ? monthsText[item.from-1] : item.from)  ;
        item.totalPrePriceText = 'סה"כ ' + item.priceText;
        item.totalPriceText = 'לחודש';
      }
      return item;
    });
  }
  else{
    priceItems = [];
  }
  return priceItems;
}

